"use strict";
(self["webpackChunktom_bihn"] = self["webpackChunktom_bihn"] || []).push([[451],{

/***/ 451:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ productDetails)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function productDetails({ wrapper }) {
    // Parse the variant metafields JSON
    const metafieldsJson = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-hook="variant-metafields"]');
    const variantMetafields = metafieldsJson.length ? JSON.parse(metafieldsJson.text()) : {};

  // update the accordion content
  function updateVariantMaterial(variantId) {
    const materialAccordion = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('[data-material-accordion]');
    const contentDiv = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('[data-variant-material]');
    
    if (!contentDiv.length || !materialAccordion.length) {
      return;
    }

    const metafield = variantMetafields[variantId]?.variant_material;
    
    if (metafield && metafield !== '') {
      contentDiv.html(metafield);
      materialAccordion.show();
    } else {
      materialAccordion.hide();
    }
  }

  // Listen for variant changes
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('variant-selector:change', (event, { variant }) => {
    updateVariantMaterial(variant.id);
  });

} 

/***/ })

}]);